
import { defineComponent } from 'vue'
import { isWechat } from '@/utils/utils'
import { ElMessage } from 'element-plus'
import { setToken } from '@/utils/auth'

export default defineComponent({
	name: 'BDialogLogin',
	props: {
		visible: Boolean,
	},
	data() {
		return {
			formRef: null,
			loginType: 'wechat',
			login: {
				email: '',
				password: '',
				mobile: '', // 原有手机号字段
				sendcode: '', // 原有验证码字段
				redirect: null,
			},
			rules: {
				email: [
					{ required: true, message: '请输入邮箱', trigger: 'blur' },
					{ type: 'email', message: '邮箱格式不正确', trigger: 'blur' },
				],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
					{ min: 8, max: 20, message: '密码长度为8-20位', trigger: 'blur' },
					{
						pattern: /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/,
						message: '密码至少8位，包含字母和数字',
					},
				],
			},
			// 原有数据字段
			disabled: false,
			showQrcode: false,
			dialogVisible: true,
			dialogWidth: '340px',
			dialogHeight: '900px',
		}
	},
	computed: {
		user(): any {
			return this.$store.state.user
		},
	},
	watch: {
		visible: {
			deep: true,
			immediate: true,
			handler(value) {
				if (value) this.wechatLogin()
				this.dialogVisible = value
			},
		},
	},
	created() {
		this.initWechatQrcode()
		let clientWidth = document.body.clientWidth - 10
		this.dialogWidth = clientWidth < 340 ? clientWidth + 'px' : '340px'
	},
	methods: {
		// 新增方法
		toggleLoginType() {
			this.loginType = this.loginType == 'account' ? 'wechat' : 'account'
			if (this.loginType == 'wechat') this.initWechatQrcode()
		},

		async handleLogin() {
			if (this.loginType === 'account') {
				try {
					//await this.$refs.loginForm.validate()
					//this.login.password = md5(this.login.password)
					const { data } = await this.$axios.post(
						'/v1/merchants/user/login/email',
						{
							email: this.login.email,
							password: this.login.password,
						}
					)
					if (data.token) {
						ElMessage.success('登录成功')
						setToken(data.token)
						location.replace('/')
					}
				} catch (error) {
					//ElMessage.error(error.response?.data?.message || '登录失败')
				}
			}
		},

		// 原有方法保留
		async initWechatQrcode() {
			const { host, protocol } = location
			const { appid, scope } = await this.getInitInfo()
			//const redirectUrl = `${protocol}//${host}/?appid=${appid}`
			const redirectUrl = `https://merchants.gblinker.com/?appid=${appid}`
			new WxLogin({
				self_redirect: false,
				id: 'wechat-qrcode',
				appid,
				scope,
				redirect_uri: encodeURIComponent(redirectUrl),
				state: +new Date(),
				style: 'white',
				href: '//res-cn.public.gblinker.com/gblinker/merchants/styles/qrcode_v1.css',
			})
		},
		async getInitInfo() {
			const { data } = await this.$axios.get('/v1/merchants/user/login/init')
			return data
		},
		dialogClose() {
			this.$emit('close')
			this.$emit('update:visible', false)
		},
		showWechatQrcode() {
			this.initWechatQrcode()
			this.showQrcode = true
		},
		async wechatLogin() {
			if (!isWechat()) return false
			if (this.user.logined) return false
			const { host, protocol } = location
			const redirectUrl = `${protocol}//${host}/wechat?appid=wx5ee8fe90b3847996`
			location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5ee8fe90b3847996&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=${+new Date()}#wechat_redirect`
		},
	},
})
